module.exports = __webpack_public_path__ + "69536cab27595e18d9691809609565a1.jpg";